<div (furyClickOutside)="onClickOutside()" class="toolbar-notifications" fxLayout="row" fxLayoutAlign="start center">
  <button (click)="toggleDropdown()" [class.open]="isOpen" class="notif-trigger-btn" mat-icon-button type="button" matTooltip="Notifications">
    <mat-icon [matBadgeHidden]="notifications.length === 0" [matBadge]="notifications.length" matBadgeColor="warn" matBadgeSize="small" class="notif-bell-icon" aria-hidden="false">
      notifications_none
    </mat-icon>
  </button>

  <div [class.open]="isOpen" class="notif-dropdown">
    <!-- Header -->
    <div class="notif-header">
      <div class="notif-header-left">
        <span class="notif-title">Notifications</span>
        @if (notifications.length > 0) {
          <span class="notif-count-pill">{{ notifications.length }} new</span>
        }
      </div>
      <button class="notif-header-close-btn" mat-icon-button type="button" (click)="onClickOutside()" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Notification List -->
    <div class="notif-list-wrapper">
      <fury-scrollbar class="notif-scroll-area">
        <div class="notif-list">
          @for (notification of notifications; track (notification.id || notification.name || $index); let last = $last) {
            <div
              (click)="markAsRead(notification, $event)"
              [@listFade]
              class="notif-item"
              [class.notif-item--unread]="!notification.read"
              [class.notif-item--error]="notification.error === true"
              matRipple>

              <!-- Icon bubble -->
              <div class="notif-icon-bubble" [class.notif-icon-bubble--error]="notification.error === true">
                <mat-icon class="notif-item-icon">{{ notification.icon || 'notifications_none' }}</mat-icon>
              </div>

              <!-- Content -->
              <div class="notif-item-content">
                <div class="notif-item-name">{{ notification.name }}</div>
              </div>

              <!-- Dismiss -->
              <button
                (click)="dismiss(notification, $event)"
                class="notif-dismiss-btn"
                mat-icon-button
                type="button"
                matTooltip="Dismiss">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        </div>

        <!-- Empty state -->
        @if (notifications.length === 0) {
          <div [@listFade] class="notif-empty">
            <mat-icon class="notif-empty-icon">notifications_off</mat-icon>
            <span class="notif-empty-title">All caught up!</span>
            <span class="notif-empty-sub">No new notifications right now.</span>
          </div>
        }
      </fury-scrollbar>
    </div>

    <!-- Footer -->
    @if (notifications.length > 1) {
      <div (click)="markAllAsRead($event)" class="notif-footer" matRipple>
        <mat-icon class="notif-footer-icon">done_all</mat-icon>
        <span>Mark all as read</span>
      </div>
    }
  </div>
</div>